<template>
  <Teleport to="body">
    <div class="fixed inset-0 bg-black/20 z-[3000] flex items-center justify-center">
      <div class="text-left bg-white rounded relative max-h-[90%] max-w-[90%] overflow-y-auto">
        <PtIcon
          icon="SolidCloseBig"
          class="!w-5 !h-5 absolute top-6 right-6 cursor-pointer"
          @click="$emit('closeDialog')"
        />
        <ThePricingSection
          :limit-reached="limitReached"
          :is-payment-loading="isPaymentLoading"
          :use-alt-title="true"
          class="!from-transparent !to-transparent"
          @cta="handleCtaClick"
        ></ThePricingSection>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import ThePricingSection from '@/components/common/upgrade/ThePricingSection.vue';
import { EurekaPackageType } from '@eureka/services/src/apis/common.api.types';
import { openClueReport } from '@eureka/shared/clue-report';
import { PtIcon } from 'patsnap-biz';
import { useHandlePro } from '@/composables/subscription/use-handle-pro';
import { onMounted } from 'vue';
import { useTracking } from '@/composables/tracking/use-tracking';
import { useMseProducts } from '@/composables/home/use-product';

const props = withDefaults(
  defineProps<{
    triggerSource: string;
    limitReached?: boolean;
  }>(),
  {
    limitReached: false,
  },
);

defineEmits(['closeDialog']);

const { sendTracking } = useTracking();
const { handleSelectPro, isPaymentLoading } = useHandlePro();
const { usedProduct } = useMseProducts();

const handleCtaClick = (tier: string, period: 'MONTHLY' | 'YEARLY') => {
  switch (tier) {
    case 'BASIC':
      break;
    case 'PRO':
      handleSelectPro(period);
      break;
    case 'ENTERPRISE':
      openClueReport({
        pkgType: EurekaPackageType.MATERIAL_COMMERCIAL,
        version: 'AIR',
      });
      break;
    case 'API':
      window.location.href = 'https://open.patsnap.com?from=eureka_mse';
      break;
  }
};

onMounted(() => {
  sendTracking('SS EUREKA UPGRADE PAGE', 'upgrade_trigger', {
    product_line: 'eureka_mse',
    trigger_source: props.triggerSource,
    agent_name: `mse_${usedProduct.value.toLowerCase()}`,
  });
  sendTracking('SS EUREKA UPGRADE PAGE', 'pricing_page_view', {
    product_line: 'eureka_mse',
    from_trigger: props.triggerSource,
  });
});
</script>
